import React, { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import { Link } from 'react-router-dom';
import { FaHome, FaExclamationTriangle } from 'react-icons/fa';
import { Helmet } from 'react-helmet-async'; // Import Helmet

const NotFound = () => {
    const { darkMode } = useContext(ThemeContext);
    const theme = useContext(ThemeContext);

    const primaryColor = theme.primaryColor || (darkMode ? '#64b5f6' : '#1e88e5');
    const secondaryColor = theme.secondaryColor || (darkMode ? '#aed581' : '#7cb342');
    const accentColor = theme.accentColor || (darkMode ? '#ffb74d' : '#f57c00');
    const textColor = darkMode ? 'text-light' : 'text-dark';
    const backgroundColor = darkMode ? 'bg-dark' : 'bg-light';

    return (
        <>
            {/* Add Helmet for SEO and HTTP Status Code
              We use `htmlAttributes` to set the language and 
              a title tag that explicitly mentions the 404 error.
              The HTTP status code (404) should ideally be handled 
              by the server/routing setup (for example, nginx or another web server), 
              but the Helmet helps client-side.
            */}
            <Helmet>
                <title>404 - Page Not Found</title>
                <meta name="robots" content="noindex" />
            </Helmet>

            <div className={`d-flex flex-column align-items-center justify-content-center min-vh-100 ${backgroundColor} ${textColor}`}>
                <div className="container text-center py-5">
                    {/* Themed Animated 404 */}
                    <div className="mb-4" style={{ fontSize: '6rem', fontWeight: 'bold' }}>
                        <FaExclamationTriangle className={`me-2 ${accentColor}`} />
                        <span style={{ color: primaryColor }}>{4}</span>
                        <span style={{ color: secondaryColor }}>{0}</span>
                        <span style={{ color: accentColor }}>{4}</span>
                    </div>

                    {/* Themed Message */}
                    <h1 className={`display-5 mb-3`} style={{ color: primaryColor }}>
                        Oops! Page Not Found
                    </h1>
                    <p className="lead mb-4">
                        The page you're looking for doesn't exist or has been moved.
                    </p>

                    {/* Themed Illustration (Simplified) */}
                    <div className="mb-4" style={{ maxWidth: '200px', margin: '0 auto' }}>
                        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="100" cy="100" r="90" fill={darkMode ? '#343a40' : '#f8f9fa'} />
                            <path
                                d="M50 70 C 70 90, 130 90, 150 70"
                                stroke={accentColor}
                                strokeWidth="8"
                                fill="none"
                                strokeLinecap="round"
                            />
                            <path
                                d="M50 130 C 70 110, 130 110, 150 130"
                                stroke={accentColor}
                                strokeWidth="8"
                                fill="none"
                                strokeLinecap="round"
                            />
                            <path
                                d="M 90 100 L 110 100"
                                stroke={primaryColor}
                                strokeWidth="12"
                                strokeLinecap="round"
                            />
                            <path
                                d="M 70 60 L 75 65 M 75 60 L 70 65"
                                stroke={secondaryColor}
                                strokeWidth="6"
                                strokeLinecap="round"
                            />
                            <path
                                d="M 125 60 L 130 65 M 130 60 L 125 65"
                                stroke={secondaryColor}
                                strokeWidth="6"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>

                    {/* Themed Action Button - Using btn-gradient */}
                    <div className="d-flex justify-content-center gap-3">
                        <Link
                            to="/"
                            className={`btn btn-lg btn-gradient`}
                            style={{ backgroundColor: primaryColor, color: 'white' }}
                        >
                            <FaHome className="me-2" />
                            Return Home
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NotFound;
